<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet"
        title="Drivers"
        subtitle="Manage owned and freelance drivers, documents, license status, and assigned vehicles.">
        <div actions>
            <p-splitButton *ngIf="canCreateDrivers && !isSisterMode" label="Add Driver" icon="fa-solid fa-plus" [model]="createDriverItems" appendTo="body" (onClick)="addOwnDriver()"></p-splitButton>
        </div>
    </app-page-hero>

    <app-page-search-panel
        title="Search Drivers"
        [activeFilters]="activeDriverFilterCount()"
        [resultText]="activeResultText()"
        [collapsed]="true"
        (search)="applyDriverFilters()"
        (clear)="clearDriverFilters()">
        <div class="formgrid grid">
            <div class="field col-12 md:col-4">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input pInputText id="driverKeyword" type="text" [(ngModel)]="driverSearchText" placeholder="Name, email, country, or address">
                        <label for="driverKeyword">Keyword Search</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-2">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input pInputText id="driverPhone" type="text" [(ngModel)]="driverPhoneSearch" placeholder="Phone">
                        <label for="driverPhone">Phone</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-2">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="fa-solid fa-id-card"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input pInputText id="driverIqama" type="text" [(ngModel)]="driverIqamaSearch" placeholder="Iqama #">
                        <label for="driverIqama">Iqama #</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-2">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="fa-solid fa-address-card"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input pInputText id="driverLicense" type="text" [(ngModel)]="driverLicenseSearch" placeholder="License #">
                        <label for="driverLicense">License #</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-2">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="fa-solid fa-truck"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <input pInputText id="driverVehicle" type="text" [(ngModel)]="driverVehicleSearch" placeholder="Plate or reg.">
                        <label for="driverVehicle">Vehicle</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
            <div class="field col-12 md:col-2">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-circle-fill"></i></p-inputGroupAddon>
                    <p-iftalabel>
                        <p-select inputId="driverStatus" [options]="driverStatusOptions" optionLabel="label" optionValue="value"
                            [(ngModel)]="driverStatusSearch" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                        <label for="driverStatus">Status</label>
                    </p-iftalabel>
                </p-inputGroup>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-metric-strip [metrics]="driverMetrics()"></app-page-metric-strip>

    <app-page-data-panel
        *ngIf="canViewDrivers"
        title="Drivers Directory"
        subtitle="Owned and freelance driver records available to fleet operations."
        [resultText]="activeResultText()">
        <div class="fleet-scope-toolbar">
            <div class="fleet-scope-switch" *ngIf="canUseSisterCompanyMode">
                <p-selectButton
                    [options]="resourceViewOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="resourceView"
                    (ngModelChange)="onResourceViewChange($event)">
                </p-selectButton>
            </div>
            <app-dashboard-company-scope-selector
                *ngIf="isSisterMode"
                [label]="'Sister company'"
                [companyGroupName]="sisterCompanyScope?.companyGroupName || ''"
                [memberCompanies]="sisterCompanies"
                [selectedCompanyId]="selectedSisterCompanyId"
                [allCompaniesLabel]="sisterCompanyAllLabel"
                [hint]="sisterCompanyFilterHint"
                (selectedCompanyIdChange)="onSisterCompanyChange($event)">
            </app-dashboard-company-scope-selector>
        </div>
        <p-tabs [value]="activeTabIndex" (valueChange)="tabChange($event)" styleClass="fleet-tabs">
            <p-tablist>
                <p-tab [value]="0">
                    <span class="fleet-tab"><i class="pi pi-building"></i><span>Owned</span></span>
                </p-tab>
                <p-tab [value]="1">
                    <span class="fleet-tab"><i class="pi pi-user"></i><span>Freelancers</span></span>
                </p-tab>
                <p-tab [value]="2">
                    <span class="fleet-tab"><i class="pi pi-calendar"></i><span>Rental</span></span>
                </p-tab>
                <p-tab [value]="3">
                    <span class="fleet-tab"><i class="pi pi-building"></i><span>Transporter</span></span>
                </p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <p-table [value]="ownedDrivers" dataKey="tableRowKey" [resizableColumns]="true"
                        styleClass="p-datatable-gridlines fleet-driver-table fleet-owned-driver-table" [tableStyle]="{ 'width': '100%' }" [paginator]="true"
                        [rows]="10" [first]="ownedFirst" [showCurrentPageReport]="true" [totalRecords]="totalOwnedRecords"
                        [lazy]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} drivers"
                        (onLazyLoad)="loadOwnedData($event)" [rowsPerPageOptions]="[10, 20, 50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Driver & Contact</th>
                                <th>Compliance</th>
                                <th>Preferred Base</th>
                                <th>Current Vehicle</th>
                                <th>Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-driver>
                            <tr>
                                <td>
                                    <div class="fleet-profile-cell">
                                        <img [src]="driver.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                            [alt]="driver.name || 'Driver'">
                                        <div class="fleet-cell-stack">
                                            <strong>{{ driver.name || '-' }}</strong>
                                            <small *ngIf="isSisterMode && driver.resourceCompanyName" class="fleet-resource-company">{{ driver.resourceCompanyName }}</small>
                                            <span><i class="pi pi-phone"></i> {{ driver.phoneNumber || '-' }}</span>
                                            <span><i class="pi pi-envelope"></i> {{ driver.emailAddress || '-' }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-meta-grid">
                                        <div>
                                            <span>Nationality</span>
                                            <strong>{{ driver.nationality?.name || '-' }}</strong>
                                        </div>
                                        <div>
                                            <span>Iqama</span>
                                            <strong>{{ driver.residenceNumber || '-' }}</strong>
                                            <small>{{ driver.residenceExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                        <div>
                                            <span>License</span>
                                            <strong>{{ driver.licenseNumber || '-' }}</strong>
                                            <small>{{ driver.licenseExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                    </div>
                                </td>
                                <td><div class="fleet-address-cell">{{ driver.preferredAddress || '-' }}</div></td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-chip [label]="driver.currentVehicle?.plateNumber || '-'"></p-chip>
                                        <span>{{ driver.currentVehicle?.registrationNumber || '' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-tag [value]="formatDriverStatus(driver.status)"
                                            [severity]="driverStatusSeverity(driver.status)"></p-tag>
                                        <p-select *ngIf="!isSisterMode" [options]="driverStatusOptions" [ngModel]="driver.status"
                                            optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"
                                            [disabled]="isDriverStatusUpdating(driver)"
                                            (onChange)="updateDriverStatus(driver, $event.value)"></p-select>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-action-buttons">
                                        <button pButton type="button" icon="pi pi-eye" (click)="viewDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-help"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-sync" (click)="changeDriverOwnership(driver)"
                                            class="p-button-rounded p-button-text p-button-warning" aria-label="Change ownership"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-pencil" (click)="editDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-secondary"></button>
                                        <button *ngIf="canDeleteDrivers && !isSisterMode" pButton type="button" icon="pi pi-trash" (click)="deleteDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-danger"></button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6"><div class="fleet-empty-state">No owned drivers found.</div></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <p-table [value]="freelancerDrivers" dataKey="tableRowKey" [resizableColumns]="true"
                        styleClass="p-datatable-gridlines fleet-driver-table fleet-owned-driver-table" [tableStyle]="{ 'width': '100%' }" [paginator]="true"
                        [rows]="10" [first]="freelancerFirst" [showCurrentPageReport]="true"
                        [totalRecords]="totalFreelancerRecords" [lazy]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} drivers"
                        (onLazyLoad)="loadFreelancerData($event)" [rowsPerPageOptions]="[10, 20, 50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Driver & Contact</th>
                                <th>Compliance</th>
                                <th>Preferred Base</th>
                                <th>Current Vehicle</th>
                                <th>Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-driver>
                            <tr>
                                <td>
                                    <div class="fleet-profile-cell">
                                        <img [src]="driver.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                            [alt]="driver.name || 'Driver'">
                                        <div class="fleet-cell-stack">
                                            <strong>{{ driver.name || '-' }}</strong>
                                            <small *ngIf="isSisterMode && driver.resourceCompanyName" class="fleet-resource-company">{{ driver.resourceCompanyName }}</small>
                                            <span><i class="pi pi-phone"></i> {{ driver.phoneNumber || '-' }}</span>
                                            <span><i class="pi pi-envelope"></i> {{ driver.emailAddress || '-' }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-meta-grid">
                                        <div>
                                            <span>Nationality</span>
                                            <strong>{{ driver.nationality?.name || '-' }}</strong>
                                        </div>
                                        <div>
                                            <span>Iqama</span>
                                            <strong>{{ driver.residenceNumber || '-' }}</strong>
                                            <small>{{ driver.residenceExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                        <div>
                                            <span>License</span>
                                            <strong>{{ driver.licenseNumber || '-' }}</strong>
                                            <small>{{ driver.licenseExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                    </div>
                                </td>
                                <td><div class="fleet-address-cell">{{ driver.preferredAddress || '-' }}</div></td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-chip [label]="driver.currentVehicle?.plateNumber || '-'"></p-chip>
                                        <span>{{ driver.currentVehicle?.registrationNumber || '' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-tag [value]="formatDriverStatus(driver.status)"
                                            [severity]="driverStatusSeverity(driver.status)"></p-tag>
                                        <p-select *ngIf="!isSisterMode" [options]="driverStatusOptions" [ngModel]="driver.status"
                                            optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"
                                            [disabled]="isDriverStatusUpdating(driver)"
                                            (onChange)="updateDriverStatus(driver, $event.value)"></p-select>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-action-buttons">
                                        <button pButton type="button" icon="pi pi-eye" (click)="viewDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-help"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-sync" (click)="changeDriverOwnership(driver)"
                                            class="p-button-rounded p-button-text p-button-warning" aria-label="Change ownership"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-pencil" (click)="editDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-secondary"></button>
                                        <button *ngIf="canDeleteDrivers && !isSisterMode" pButton type="button" icon="pi pi-trash" (click)="deleteDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-danger"></button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6"><div class="fleet-empty-state">No freelance drivers found.</div></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <p-table [value]="rentalDrivers" dataKey="tableRowKey" [resizableColumns]="true"
                        styleClass="p-datatable-gridlines fleet-driver-table fleet-rental-driver-table" [tableStyle]="{ 'width': '100%' }" [paginator]="true"
                        [rows]="10" [first]="rentalFirst" [showCurrentPageReport]="true"
                        [totalRecords]="totalRentalRecords" [lazy]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} drivers"
                        (onLazyLoad)="loadRentalData($event)" [rowsPerPageOptions]="[10, 20, 50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Driver & Contact</th>
                                <th>Compliance</th>
                                <th>Current Vehicle</th>
                                <th>Rental Terms</th>
                                <th>Rental Status</th>
                                <th>Driver Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-driver>
                            <tr>
                                <td>
                                    <div class="fleet-profile-cell">
                                        <img [src]="driver.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                            [alt]="driver.name || 'Driver'">
                                        <div class="fleet-cell-stack">
                                            <strong>{{ driver.name || '-' }}</strong>
                                            <small *ngIf="isSisterMode && driver.resourceCompanyName" class="fleet-resource-company">{{ driver.resourceCompanyName }}</small>
                                            <span><i class="pi pi-phone"></i> {{ driver.phoneNumber || '-' }}</span>
                                            <span><i class="pi pi-envelope"></i> {{ driver.emailAddress || '-' }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-meta-grid">
                                        <div>
                                            <span>Iqama</span>
                                            <strong>{{ driver.residenceNumber || '-' }}</strong>
                                            <small>{{ driver.residenceExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                        <div>
                                            <span>License</span>
                                            <strong>{{ driver.licenseNumber || '-' }}</strong>
                                            <small>{{ driver.licenseExpiryDate | date:'dd/MM/yyyy' }}</small>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-chip [label]="driver.currentVehicle?.plateNumber || '-'"></p-chip>
                                        <span>{{ driver.currentVehicle?.registrationNumber || '' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <strong>{{ driver.rentalVendorName || '-' }}</strong>
                                        <span>Ref: {{ driver.rentalContractReferenceNumber || '-' }}</span>
                                        <span>{{ driver.rentalStartDate | date:'dd/MM/yyyy' }} - {{ driver.rentalEndDate | date:'dd/MM/yyyy' }}</span>
                                        <span>{{ driver.rentalRateAmount || '-' }} {{ driver.rentalRateCurrency || 'SAR' }} / {{ driver.rentalRatePeriod || 'DAY' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <p-tag [value]="isRentalExpired(driver) ? 'Expired' : (driver.rentalStatus || 'ACTIVE')"
                                        [severity]="isRentalExpired(driver) ? 'danger' : 'success'"></p-tag>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <p-tag [value]="formatDriverStatus(driver.status)"
                                            [severity]="driverStatusSeverity(driver.status)"></p-tag>
                                        <p-select *ngIf="!isSisterMode" [options]="driverStatusOptions" [ngModel]="driver.status"
                                            optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"
                                            [disabled]="isDriverStatusUpdating(driver)"
                                            (onChange)="updateDriverStatus(driver, $event.value)"></p-select>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-action-buttons">
                                        <button pButton type="button" icon="pi pi-eye" (click)="viewDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-help"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-sync" (click)="changeDriverOwnership(driver)"
                                            class="p-button-rounded p-button-text p-button-warning" aria-label="Change ownership"></button>
                                        <button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-pencil" (click)="editDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-secondary"></button>
                                        <button *ngIf="canDeleteDrivers && !isSisterMode" pButton type="button" icon="pi pi-trash" (click)="deactivateRentalDriver(driver)"
                                            class="p-button-rounded p-button-text p-button-danger"></button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7"><div class="fleet-empty-state">No rental drivers found.</div></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-tabpanel>
                <p-tabpanel [value]="3">
                    <div class="formgrid grid mb-3">
                        <div class="field col-12 md:col-6">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="fa-solid fa-building-truck"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-select inputId="driverTransporter" [options]="transporterOptions"
                                        optionLabel="transporterName" optionValue="crmClientId"
                                        [ngModel]="selectedTransporterCrmClientId"
                                        (ngModelChange)="onTransporterChange($event)" [showClear]="true"
                                        [filter]="true" filterBy="transporterName,crmClientNumber,linkedCompanyName"
                                        appendTo="body" styleClass="w-full"></p-select>
                                    <label for="driverTransporter">Transporter agency</label>
                                </p-iftalabel>
                            </p-inputGroup>
                            <small class="text-color-secondary">Select a CRM transporter to view only its agency drivers.</small>
                        </div>
                    </div>
                    <p-table [value]="transporterDrivers" dataKey="tableRowKey" [resizableColumns]="true"
                        styleClass="p-datatable-gridlines fleet-driver-table fleet-owned-driver-table" [tableStyle]="{ 'width': '100%' }" [paginator]="true"
                        [rows]="transporterRows" [first]="transporterFirst" [showCurrentPageReport]="true"
                        [totalRecords]="totalTransporterRecords" [lazy]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transporter drivers"
                        (onLazyLoad)="loadTransporterData($event)" [rowsPerPageOptions]="[10, 20, 50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Driver & Contact</th>
                                <th>Transporter</th>
                                <th>Compliance</th>
                                <th>Current Vehicle</th>
                                <th>Status</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-driver>
                            <tr>
                                <td>
                                    <div class="fleet-profile-cell">
                                        <img [src]="driver.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
                                            [alt]="driver.name || 'Driver'">
                                        <div class="fleet-cell-stack">
                                            <strong>{{ driver.name || '-' }}</strong>
                                            <span><i class="pi pi-phone"></i> {{ driver.phoneNumber || '-' }}</span>
                                            <span><i class="pi pi-envelope"></i> {{ driver.emailAddress || '-' }}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-cell-stack">
                                        <strong>{{ selectedTransporterName }}</strong>
                                        <span>{{ driver.resourceCompanyName || 'Transporter agency' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="fleet-meta-grid">
                                        <div><span>Iqama</span><strong>{{ driver.residenceNumber || '-' }}</strong></div>
                                        <div><span>License</span><strong>{{ driver.licenseNumber || '-' }}</strong></div>
                                    </div>
                                </td>
                                <td><div class="fleet-cell-stack"><p-chip [label]="driver.currentVehicle?.plateNumber || '-'"></p-chip><span>{{ driver.currentVehicle?.registrationNumber || '' }}</span></div></td>
                                <td><p-tag [value]="formatDriverStatus(driver.status)" [severity]="driverStatusSeverity(driver.status)"></p-tag></td>
                                <td><div class="fleet-action-buttons"><button pButton type="button" icon="pi pi-eye" (click)="viewDriver(driver)" class="p-button-rounded p-button-text p-button-help"></button><button *ngIf="canEditDrivers && !isSisterMode" pButton type="button" icon="pi pi-sync" (click)="changeDriverOwnership(driver)" class="p-button-rounded p-button-text p-button-warning" aria-label="Change ownership"></button></div></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage"><tr><td colspan="6"><div class="fleet-empty-state">Select a transporter to view its drivers.</div></td></tr></ng-template>
                    </p-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
</app-page-shell>

<app-quick-fleet-onboarding-dialog [(visible)]="quickFleetOnboardingVisible" [defaultSource]="quickFleetOnboardingSource" [defaultTransporterCrmClientId]="selectedTransporterCrmClientId" (completed)="onQuickFleetOnboarded()"></app-quick-fleet-onboarding-dialog>
<app-fleet-ownership-transfer-dialog [(visible)]="ownershipTransferVisible" [owningCompanyId]="currentCompanyId"
    [resources]="ownershipTransferResources" [pairedResource]="ownershipTransferPairedResource"
    (completed)="onOwnershipTransferCompleted()"></app-fleet-ownership-transfer-dialog>

<p-dialog header="Add Freelancer Driver" [(visible)]="showAddFreelancerDriverDialog" [modal]="true"
    [style]="{width: 'min(92vw, 36rem)'}" [draggable]="false" [resizable]="false">
    <div class="p-fluid">
        <div class="field">
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
                <input id="driverPhoneNumber" type="text" pInputText [(ngModel)]="driverPhoneNumber" placeholder="Driver phone number" />
            </p-inputGroup>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="showAddFreelancerDriverDialog = false"></p-button>
        <p-button label="Search" icon="pi pi-search" (onClick)="searchDriver()" [loading]="searchDriverInProgress"></p-button>
    </ng-template>
</p-dialog>
